"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/dashboard/v1/legacy_portal_service.proto (package spwn.dashboard.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalDashboardService = void 0;
const legacy_portal_service_pb_1 = require("./legacy_portal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.dashboard.v1.LegacyPortalDashboardService
 */
exports.LegacyPortalDashboardService = {
    typeName: "spwn.dashboard.v1.LegacyPortalDashboardService",
    methods: {
        /**
         * チケットidを元にチケットの詳細情報を取得
         *
         * @generated from rpc spwn.dashboard.v1.LegacyPortalDashboardService.GetAllIssuedTicketSummary
         */
        getAllIssuedTicketSummary: {
            name: "GetAllIssuedTicketSummary",
            I: legacy_portal_service_pb_1.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest,
            O: legacy_portal_service_pb_1.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=legacy_portal_service_connect.js.map